const hrMenu = [
  {
    System: 'HR',
    isActive: false,
    menu: [
      { is_header: true, title: '', isActive: true },
    
      {
        path: '/HR/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage'
      },

      { is_header: true, title: 'Settings', isActive: true },

      {
        path: '/HR/settings/Job',
        title: 'Jobs',
        icon: 'bi bi-briefcase',
        permission: 'ViewlistHrPerJob',
        isActive: true
      },
      {
        path: '/HR/settings/JobGrade',
        title: 'Jobgrades',
        icon: 'bi-layers',
        permission: 'ViewlistHrPerGrade',
        isActive: true
      },
      {
        path: '/HR/settings/Location',
        title: 'Locations',
        icon: 'bi bi-geo-alt',
        permission: 'listHrLocation',
        isActive: true
      },
      {
        path: '/HR/settings/Position',
        title: 'Positions',
        icon: 'bi bi-person-badge',
        permission: 'listHrPerPosition',
        isActive: true
      },
      {
        path: '/HR/settings/StaffGroup',
        title: 'Staffgroup',
        icon: 'bi bi-person-lines-fill',
        permission: 'listHrPerGroups',
        isActive: true
      },

      { is_header: true, title: 'Organizations', isActive: true },

      // {
      //   path: '/Org/Organizations',
      //   title: 'Organizations',
      //   icon: 'bi bi-building',
      //   permission: 'ListHrDepartments',
      //   isActive: true
      // },
      {
        path: '/HR/Organizations',
        title: 'OrganizationalUnits',
        icon: 'bi bi-buildings',
        permission: 'ListHrDepartments',
        isActive: true
      },
      // {
      //   path: '/Org/Departments',
      //   title: 'List_Organizations',
      //   icon: 'bi bi-building',
      //   permission: 'ListHrDepartments',
      //   isActive: true
      // },

      {
        path: '/HR/OrganizationStructure',
        title: 'OrganizationalStructure',
        icon: 'bi bi-diagram-3',
        permission: 'ViewStructureHrDepartments',
        isActive: true
      },

      { is_header: true, title: 'employees', isActive: true },

      {
        path: '/HR/Employees',
        icon: 'bi bi-people',
        title: 'employees',
        permission: 'ViewlistHrPerson',
        isActive: true
      },

      {
        path: '/HR/Delegation',
        icon: 'bi bi-shield-check',
        title: 'Delegations',
        permission: 'ViewlistHrPerDelegation',
        isActive: true
      },

      { is_header: true, title: 'Reports', isActive: true },

      {
        path: '/HR/Reports',
        icon: 'bi bi-clipboard-data-fill',
        title: 'Reports',
        isActive: true
      },

      {
        path: '/HrDashboard',
        icon: 'bi bi-cpu',
        title: 'Dashboard',
        isActive: true
      }
    ]
  }
];

export default hrMenu;

// const hrMenu = [
//   {
//     System: 'HR',
//     isActive: false,
//     menu: [
//       { is_header: true, title: 'HumanResources', isActive: true },
//       {
//         path: 'SystemDashboard',
//         icon: 'fas fa-home',
//         title: 'HomePage',
//       },

//       {
//         path: '/HRsettings',
//         icon: 'bi bi-gear',
//         title: 'Settings',
//         children: [
//           {
//             path: '/HRsettings/Job',
//             title: 'Jobs',
//             isActive: HasPermission('ViewlistHrPerJob'),
//           },
//           {
//             path: '/HRsettings/JobGrade',
//             title: 'Jobgrades',
//             isActive: HasPermission('ViewlistHrPerGrade'),
//           },
//           {
//             path: '/HRsettings/Location',
//             title: 'Locations',
//             isActive: HasPermission('listHrLocation'),
//           },
//           {
//             path: '/HRsettings/Position',
//             title: 'Positions',
//             isActive: HasPermission('listHrPerPosition'),
//           },
//           {
//             path: '/HRsettings/StaffGroup',
//             title: 'Staffgroup',
//             isActive: HasPermission('listHrPerGroups'),
//           },
//         ],
//       },
//       //
//       {
//         path: '/Org',
//         icon: 'bi bi-building',
//         title: 'Organizations',
//         children: [
//           {
//             path: '/Org/Departments',
//             title: 'List_Organizations',
//             isActive: HasPermission('ListHrDepartments'),
//           },

//           {
//             path: '/Org/OrganizationStructure',
//             title: 'OrganizationalStructure',
//             isActive: HasPermission('ViewStructureHrDepartments'),
//           },
//         ],
//       },

//       {
//         path: 'HR/Employees',
//         icon: 'bi bi-people',
//         title: 'employees',
//         // isActive: HasPermission('ViewlistHrPerson'),
//         isActive: canViewlistHrPerson,
//       },

//       {
//         path: 'HR/Delegation',
//         icon: 'bi bi-shield-check',
//         title: 'Delegations',
//         isActive: HasPermission('ViewlistHrPerDelegation'),
//       },

//       {
//         path: 'HR/Reports',
//         icon: 'bi bi-clipboard-data-fill',
//         title: 'Reports',
//         isActive: true,
//       },

//       {
//         path: 'HrDashboard',
//         icon: 'bi bi-cpu',
//         title: 'Dashboard',
//         isActive: true,
//         // highlight: true,
//       },
//     ],
//   },
// ];
